import { useEffect, useMemo, useRef, useState } from 'react';
import { useDataApi } from '@adsk/alloy-helpers';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import {
  buildGetAccountUserSheetCountRequest,
  getUserLimitedOffering,
} from '../utils';

const useUserSheet = ({ user, userOfferingsData }) => {
  const accountId = useCurrentAccountId();
  const isOverSheetBanner = useRef(false);
  const [forceUpdateValue, forceUpdate] = useState(0);

  const {
    data: userSheetCountData,
    doFetch: doFetchUserSheetCount,
    error: sheetCountError,
  } = useDataApi();

  useEffect(() => {
    if (user && accountId) {
      doFetchUserSheetCount(
        buildGetAccountUserSheetCountRequest(accountId, user.id)
      );
    }
  }, [user, accountId, doFetchUserSheetCount]);

  const isOverSheetLimit = useMemo(() => {
    if (!userSheetCountData || !userOfferingsData) return null;

    const offering = getUserLimitedOffering(userOfferingsData.results);

    return offering && userSheetCountData.sheetCount > offering.sheetLimit;
  }, [userOfferingsData, userSheetCountData]);

  useEffect(() => {
    if (!isOverSheetLimit && isOverSheetBanner.current) {
      isOverSheetBanner.current = false;

      return;
    }

    if (isOverSheetLimit && !isOverSheetBanner.current) {
      isOverSheetBanner.current = true;
    }
  }, [isOverSheetLimit]);

  const hideOverSheetBanner = () => {
    isOverSheetBanner.current = false;

    forceUpdate(forceUpdateValue + 1);
  };

  return {
    userSheetCount: userSheetCountData && userSheetCountData.sheetCount,
    isOverSheetBanner: isOverSheetBanner.current,
    hideOverSheetBanner,
    sheetCountError,
  };
};

export default useUserSheet;
